/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import clsx from 'clsx'
import { KTSVG } from '../../../../helpers'
import { Dropdown1 } from '../../../../partials'
import { IToolbarItem, ToolbarItemButton, ToolbarItemDropdown, useLayout } from '../../../core'
import { ToolbarProps } from '../Toolbar'

const ToolbarClassic = (props: ToolbarProps) => {
    const { config } = useLayout();
    const daterangepickerButtonClass = config.app?.toolbar?.fixed?.desktop
        ? 'btn-light'
        : 'bg-body btn-color-gray-700 btn-active-color-primary';

    const renderButton = (item: ToolbarItemButton, index: number) =>
    (
        <a
            key={`toolbar-item-${item.type}-${index}`}
            href='#'
            onClick={item.onClick}
            className='btn btn-sm fw-bold btn-primary tp-btn-toolbar'
        >
            <i className={item.icon ?? ""}></i> {item.label}
        </a>
    )


    const renderDropdown = (item: ToolbarItemDropdown, _: number) => (<>{item.label}</>)

    const renderItem = (item: IToolbarItem, index: number) => {
        if (!item.component || !item?.display) {
            return <></>;
        }
        switch (item.component.type) {
            case 'button':
                return renderButton(item.component, index);
            case 'dropdown':
                return renderDropdown(item.component, index);
            case 'custom':
                return <div key={item?.key}> {item.component.render()} </div>;
            default:
                return <> </>;
        }
    }

    return (
        <div className='d-flex align-items-center gap-2 gap-lg-3 ' style={{ minHeight: '50px' }}>
            {props.items.map((item: IToolbarItem, index: number) => <div key={index}> {renderItem(item, index)} </div>)}
            {config.app?.toolbar?.filterButton && (
                <div className='m-0'>
                    <a
                        href='#'
                        className={clsx('btn btn-sm btn-flex fw-bold', daterangepickerButtonClass)}
                        data-kt-menu-trigger='click'
                        data-kt-menu-placement='bottom-end'
                    >
                        <KTSVG
                            path='/media/icons/duotune/general/gen031.svg'
                            className='svg-icon-6 svg-icon-muted me-1'
                        />
                        Filter
                    </a>
                    <Dropdown1 />
                </div>
            )}

            { // TODO: Export
                config.app?.toolbar?.daterangepickerButton && (
                    <div
                        data-kt-daterangepicker='true'
                        data-kt-daterangepicker-opens='left'
                        className={clsx(
                            'btn btn-sm fw-bold  d-flex align-items-center px-4',
                            daterangepickerButtonClass
                        )}
                    >
                        <div className='text-gray-600 fw-bold'>Loading date range...</div>
                        <KTSVG path='/media/icons/duotune/general/gen014.svg' className='svg-icon-1 ms-2 me-0' />
                    </div>
                )}


            { //TODO: export
                config.app?.toolbar?.secondaryButton && (
                    <a href='#' className='btn btn-sm btn-flex btn-light fw-bold'>
                        Filter
                    </a>
                )}

        </div>
    )
};

export { ToolbarClassic }
